import { Component, ElementRef, EventEmitter, Input, Output, QueryList, ViewChildren } from '@angular/core';
import { ComponentsGroup } from '../../../../../../models/componentGroup.model';
import { Component as ComponentModel } from './../../../../../../models/component.model';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ComponentType } from '../../../../../../shared/enums/component-type/component-type.module';
import { Direction } from '../../../../../../shared/enums/direction/direction.module';

@Component({
  selector: 'app-group-config',
  templateUrl: './group-config.component.html',
  styleUrl: './group-config.component.css'
})
export class GroupConfigComponent {
  ComponentType = ComponentType;
  @Input() componentsGroup!: ComponentsGroup;
  @Input() selectedComponentId!: string | null;

  Direction = Direction;

  @Output() componentSelected = new EventEmitter<{ componentId: string, groupId: string, open?: string }>();
  @Output() reorderComponents = new EventEmitter;

  @ViewChildren('componentElement', { read: ElementRef }) componentElements!: QueryList<ElementRef>;

  getComponentSize(component: ComponentModel): string {
    return `col-12 col-lg-${component.size} col-md-${component.size}`;
  }

  onSelectComponent(event: MouseEvent, componentId: string, groupId: string, open?: string){
    event.stopPropagation();
    if(componentId !== this.selectedComponentId)
    {
      this.componentSelected.emit({ componentId, groupId, open });
    }
  }

  dropComponent(event: CdkDragDrop<any[]>): void {
    moveItemInArray(this.componentsGroup.components, event.previousIndex, event.currentIndex);
    this.updateComponentOrder();
    this.reorderComponents.emit();
  }

  updateComponentOrder(): void {
    this.componentsGroup.components.forEach((component, index) => {
      component.order = index + 1;
    });
  }

  scrollToComponent(componentIndex: number) {
    const componentElement = this.componentElements.toArray()[componentIndex];
    if (componentElement) {
        componentElement.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
  }

  hasRoles(component: ComponentModel): boolean{
    return component.roles != undefined && component.roles.some(x => x.isActive === true);
  }

  hasConditions(component: ComponentModel): boolean{
    return component.conditions != undefined && component.conditions!.some(x => x.rules.length > 0);
  }

  hasConnections(component: ComponentModel, direction: Direction): boolean{
    return component.connections != undefined && component.connections!.some(x => x.direction == direction);
  }

  hoveredComponentId: string | null = null;

  onHoverStart(componentId: string) {
    this.hoveredComponentId = componentId;
  }

  onHoverEnd(componentId: string) {
    if (this.hoveredComponentId === componentId) {
      this.hoveredComponentId = null;
    }
  }
}
